import script from "./WeChatContactMsgWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./WeChatContactMsgWindow.vue?vue&type=script&lang=ts&setup=true"

import "./WeChatContactMsgWindow.vue?vue&type=style&index=0&id=61028930&lang=css"

const __exports__ = script;

export default __exports__